import { SetupContext, getCurrentInstance, ref } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import Toast from 'vant/lib/toast';
import { saveAs } from 'file-saver';
import { Feed, FeedApiService } from '@/api/feed';
import { ResponseBaseResult } from '@/api/base';

type PhotoActionItemProps = {
    index?: number;
    feed?: Feed;
    isLoginStatus?: boolean;
};

export const PhotoActionItemSeoSetup = (props: PhotoActionItemProps, ctx: SetupContext<Array<'onCommentBtnClick' | 'sendActionRecoLog'>>) => {
    const FeedApi = new FeedApiService();
    const { proxy } = getCurrentInstance() || {};
    const isLiked = ref(false);
    const isVideoDownloading = ref(false);

    const excuteLikeAction = debounce(async () => {
        ctx.emit('sendActionRecoLog', 'PWA_LIKE_PHOTO');

        if (!props.isLoginStatus) {
            (proxy as Record<string, any>)?.$bus?.emit?.('changeLoginPopupShow', true);
            return;
        }

        if (isLiked.value) {
            return;
        }

        const res = await FeedApi.changeFeedLikedStatus({
            fromPage: 'new_discover',
            cancel: false,
            photoId: props?.feed?.photo_id_str,
        });

        if (res?.result === ResponseBaseResult.RESULT_OK) {
            isLiked.value = true;
        } else {
            if (res?.result === ResponseBaseResult.RESULT_TOKEN_EXPIRED || res?.result === ResponseBaseResult.RESULT_USER_ACCOUNT_ERROR) {
                (proxy as Record<string, any>)?.$bus?.emit?.('changeLoginPopupShow', true);
                return;
            }

            res?.error_msg &&
                Toast({
                    message: res?.error_msg,
                });
        }
    }, 300);

    const excuteCommentAction = debounce(async () => {
        ctx.emit('sendActionRecoLog', 'PWA_COMMENT_BUTTON');

        if (!props.isLoginStatus) {
            (proxy as Record<string, any>)?.$bus?.emit?.('changeLoginPopupShow', true);
            return;
        }

        ctx.emit('onCommentBtnClick');
    });

    const excuteDownloadAction = debounce(async () => {
        ctx.emit('sendActionRecoLog', 'PWA_DOWNLOAD_BUTTON');
        if (!props.isLoginStatus) {
            (proxy as Record<string, any>)?.$bus?.emit?.('changeLoginPopupShow', true);
            return;
        }

        Toast({
            message: (proxy as Record<string, any>)?.$root?.$t?.('download_started'),
        });

        if (!isVideoDownloading.value) {
            isVideoDownloading.value = true;
            try {
                const videoUrl = props.feed?.main_mv_urls?.find?.(mv => !!mv?.url)?.url || '';

                if (videoUrl) {
                    const response = await fetch(videoUrl);
                    if (!response.ok) throw new Error('Network response was not ok');
                    const blob = await response.blob();
                    saveAs(blob, `video_${props.feed?.photo_id_str}.mp4`);
                } else {
                    throw new Error('Video URL not found');
                }
            } catch (error) {
                console.error('Error downloading video:', error);
            } finally {
                isVideoDownloading.value = false;
            }
        }
    });

    return {
        isLiked,
        excuteLikeAction,
        excuteCommentAction,
        excuteDownloadAction,
    };
};
